import { Injectable } from '@angular/core';

import { ApiService } from '@docorga-v1/docorga-angular';

@Injectable()
export class UploadService {
  constructor(private ApiService: ApiService) {}

  public upload(uri: string, data: FormData) {
    return this.ApiService.post(uri, data);
  }
}
